import { Box, Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

import { ExpensesForm } from './ExpensesForm'
import { ExpensesTable } from './ExpensesTable'

export const OtherExpensesStep = ({ useFetchInit, readOnlyMode }) => {

    const { Actions } = useFetchInit
    const { handleClickReturnStep, handleClickNextStep } = Actions

    return (
        <>
            <ExpensesForm useFetchInit={useFetchInit} readOnlyMode={readOnlyMode} />
            <div className="pt-2"></div>
            <ExpensesTable useFetchInit={useFetchInit} readOnlyMode={readOnlyMode} />

            <div className="pt-4"></div>
            <Box className="text-center" sx={{mt: 2}}>
                <Button 
                    variant="contained"
                    type="button"
                    onClick={handleClickReturnStep} 
                    sx={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                >
                    <ArrowLeftCircle/>
                </Button>
                <Button
                    variant="contained"
                    type='button'
                    onClick={handleClickNextStep}
                    style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                >
                    <ArrowRightCircle/>
                </Button>
            </Box>
        </>
    )
}
